import isAfter from 'date-fns/isAfter'
import subDays from 'date-fns/subDays'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  if (args === void 0) args = []
  const backDays = args[0]
  if (backDays !== null && backDays !== undefined) {
    if (backDays === 0) {
      return `The ${field} cannot be back dated.`
    } else {
      return `The ${field} can only be back dated ${backDays} day(s).`
    }
  } else {
    return `The ${field} is invalid.`
  }
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    const backDays = args[0]
    if (backDays !== null && backDays !== undefined) {
      let limitDate = removeTime(subDays(new Date(), backDays))
      if (isAfter(limitDate, removeTime(value))) return false
      else return true
    } else return true
  } else return true
}

export default {
  getMessage,
  validate
}
